// extracted by mini-css-extract-plugin
var _1 = "src-components-ErrorPage-ErrorPage__errorPage--BpVp8LZsM9BuOSdTXfkS";
export { _1 as "errorPage" }
